export function Timestamp(props) {
	let {
		separator,              // Separator for parts of the date
		dateString,             // A Parseable Timestamp
		millis,                 // Alternate - milliseconds from the epoch
		className,              // Class name for styling
		expirationCutoffMillis, // If the date is before this value, add text-danger
		formatter,              // custom formatter
		...passableProps
	} = props;

	// Figure out the actual date
	let date = null;
    if(millis) {
        date = new Date(millis);
    }
	if(!!dateString) {
		millis = Date.parse(props.dateString);
		date = new Date(millis);
	}

	// Early exit if there is no date
	if(date == null) {
		return <span className={className} {...passableProps}></span>;
	}

	// Display the date properly
	let dateStringResult = "";
	if(formatter == null) {
		separator = separator || "/";
		let day = date.getDate();
		let month = date.getMonth() + 1;
		let year = date.getFullYear();
		dateStringResult = `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${day<10?`0${day}`:`${day}`}`;	
	} else {
		dateStringResult = formatter(date);
	}

	// Expiration time warning
	let expired = false;
	if(expirationCutoffMillis) {
		if(millis < expirationCutoffMillis) {
			expired = true;
		}
	}
        
    return (
        <span className={expired ? `text-danger ${className}` : className} {...passableProps}>{dateStringResult}</span>
    );
}